export const FETCH_USER = "USER/FETCH_USER";
export const DELETE_USER = "USER/DELETE_USER";